import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from 'ia-react-core';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ErrorIcon } from '../../assets/Robot-error.svg';
import {
  StyledActionBar,
  StyledErrorMessage, StyledIcon, StyledParagraph,
  StyledTitle,
  StyledWrapper,
} from '../ErrorPages.styles';
import redirectTo from '../../utils/redirectTo';

export interface TechnicalErrorPageProps {
  redirectUrl?: string;
  externalRedirect?: boolean;
  redirectButtonMessage?: string;
}

const TechnicalErrorPage: FC<TechnicalErrorPageProps> = (props) => {
  const { redirectUrl = '/' } = props;
  const { externalRedirect = false } = props;
  const { redirectButtonMessage } = props;
  const navigate = useNavigate();
  const { t } = useTranslation('TechnicalErrorPage');
  const handleRedirect = useCallback(() => {
    if (!externalRedirect) {
      redirectTo(redirectUrl, navigate);
    } else {
      window.location.href = redirectUrl;
    }
  }, [externalRedirect, redirectUrl, navigate]);
  return (

    <StyledWrapper>
      <StyledErrorMessage>
        <StyledIcon as={ErrorIcon} />
        <StyledTitle data-testid="technicalErrorTitle">{t('title')}</StyledTitle>
        <StyledParagraph>
          {t('message')}
        </StyledParagraph>
        <StyledActionBar>
          <PrimaryButton onClick={handleRedirect}>{redirectButtonMessage || t('technicalErrorButton')}</PrimaryButton>
        </StyledActionBar>
      </StyledErrorMessage>
    </StyledWrapper>
  );
};
export default TechnicalErrorPage;
